module.exports = __webpack_public_path__ + "static/media/icon-privacy-policy.9333d8ac.svg";